import { Fragment } from "react";
import { Grid as MuiGrid, useMediaQuery } from "@mui/material";

import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IMerge } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { MergeItem } from "./item";

export const MergeList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IMerge>
  >("/recipes/merge", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "recipes", "recipes.merge-list"]} />

      <PageHeader message="pages.recipes.merge-list.title" />

      <SearchWithFilters endAdornment={null} />

      <ProgressOverlay isLoading={isLoading}>
        <MuiGrid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(recipe => (
              <MuiGrid size={{ lg: 4, sm: 6, xs: 12 }} key={recipe.id}>
                <MergeItem merge={recipe} />
              </MuiGrid>
            ))}
          </StyledEmptyWrapper>
        </MuiGrid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
